(function () {
    'use strict';

    angular.module('swif.ui')
    .directive('swifFormErrors', swifFormErrors);

    /**
    * @ngdoc directive
    * @name swif.ui:swifFormErrors
    * @module swif.ui
    * @restrict E
    * @description
    * @usage
        <div swif-form-errors ng-model="form[name]"></div>
    **/
    function swifFormErrors() {
        return {
            restrict: 'A',
            replace: true,
            scope: {
                ngModel: '=',
            },
            link: function (scope, element) {
                scope.$watchGroup(['ngModel.$dirty', 'ngModel.$invalid'], function (newV) {
                    let dirty = newV[0];
                    let invalid = newV[1];
                    if (!dirty || !invalid) {
                        element.addClass('ng-hide');
                    } else {
                        element.removeClass('ng-hide');
                    }
                });
            },
            templateUrl: 'partials/ui/formErrors.html'
        };
    }

})();
